export const TAB_ID_KEY = "tabId";

export function getParametersFromUrl(): URLSearchParams {
  if (typeof window === "object") {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    return urlParams;
  }
  return new URLSearchParams("");
}

export function getQueryFromUrl() {
  if (typeof window === "object") {
    const queryString = window.location.href.split("#");
    if (queryString.length > 1) {
      return queryString[1];
    }
  }
  return "";
}

export function getDomainFromUrl() {
  if (typeof window === "object") {
    const queryString = window.location.href.split("#");
    return queryString[0];
  }
  return "";
}

export function addOrUpdateUrlParameter(key: string, value: string) {
  const queryParams = new URLSearchParams(window.location.search);
  queryParams.set(key, value);
  let url = `?${queryParams.toString()}`;
  const query = getQueryFromUrl();
  if (query !== "") {
    url += `#${query}`;
  }
  history.replaceState(null, "", url);
}

export function getValueFromUrlParameter(
  parameter: string,
  defaultValue = ""
): string {
  const urlParams = getParametersFromUrl();
  return urlParams.get(parameter) ?? defaultValue;
}

/**
 * Return `window.location.search` for cross-route navigation, minus any
 * params in `stripKeys`. Route-specific params (e.g. `tabId` for the
 * Validation page) should not leak onto other routes.
 */
export function getSearchForNavigation(
  stripKeys: ReadonlyArray<string> = []
): string {
  if (typeof window !== "object") return "";
  const params = new URLSearchParams(window.location.search);
  stripKeys.forEach((key) => params.delete(key));
  const serialized = params.toString();
  return serialized === "" ? "" : `?${serialized}`;
}
